import { PRODUCT_NAME } from "@kuroo/brand";
import type { PublicBranding } from "@kuroo/contracts";
import { KurooClient } from "@kuroo/sdk";

export const apiBaseUrl = import.meta.env.VITE_API_URL ?? "http://localhost:8787";
export const portalUrl = import.meta.env.VITE_PROVIDER_PORTAL_URL ?? (
  typeof window !== "undefined" && /^(localhost|127\.0\.0\.1)$/u.test(window.location.hostname)
    ? "http://localhost:5175/"
    : "https://kuroo-portal-production.pages.dev/"
);
export const client = new KurooClient({ baseUrl: apiBaseUrl });
export const environmentLabel = /production/i.test(apiBaseUrl) ? "PRODUCTION" : "DEVELOPMENT";
export const fallbackBranding: PublicBranding = { productName: PRODUCT_NAME, businessName: "Kuroo", logoUrl: null, primaryColor: "#6D5EF8", accentColor: "#22D3EE", locale: "es", timezone: "UTC", currency: "EUR" };

export function brandingAsset(value: string | null | undefined): string | undefined {
  if (!value) return undefined;
  if (/^https?:\/\//i.test(value)) return value;
  return `${apiBaseUrl.replace(/\/$/, "")}${value.startsWith("/") ? value : `/${value}`}`;
}
